<template>
    <div>
        <!-- cart_block -->
        <div class="row cart_block mt_sm">
            <div class="col-12">
                <div class="info_title cart_group_title">
                    Выберите <b>получателя заказа</b>.
                </div>
                <div class="info_body">
                    <div class="form-inline ki_options">
                        <input
                            class="form-control info_body_selected"
                            :class="{ 'is-invalid': errors.recipient }"
                            v-model="recipient.name"
                            readonly
                        />
                        <button
                            type="button"
                            class="btn btn_lg btn_common"
                            data-toggle="modal"
                            data-target="#modalRecipient"
                        >
                            Выбрать получателя
                        </button>
                    </div>

                    <div v-if="recipient.id != 1 && recipient.id != null" class="form-group mt_sm">
                        <label for="ki_01_01">ФИО получателя</label>
                        <input
                            type="text"
                            class="form-control"
                            :class="{ 'is-invalid': errors.contactName }"
                            id="ki_01_01"
                            v-model="contact.name"
                            @change="changeRecipientName()"
                        />
                    </div>

                    <div v-if="recipient.id != 1 && recipient.id != null" class="form-group mt_sm">
                        <label for="ki_01_01">Телефон получателя</label>
                        <input
                            type="text"
                            class="form-control"
                            :class="{ 'is-invalid': errors.contactPhone }"
                            id="ki_01_01"
                            v-model="contact.phone"
                            @change="changeRecipientPhone()"
                        />
                    </div>
                </div>
            </div>
        </div>
        <!-- //cart_block -->
                        
        <order-form-recipient-modal></order-form-recipient-modal>
        
    </div>
</template>

<script>
export default {
    methods: {
        changeRecipientName() {
            this.$store.dispatch('order/changeRecipientName');
        },
        changeRecipientPhone() {
            this.$store.dispatch('order/changeRecipientPhone');
        },
    },
    computed: {
        // Выбранный получатель
        recipient() {
            return this.$store.state.order.recipient;
        },
        // Имя и телефон
        contact() {
            return this.$store.state.order.contact;
        },
        errors() {
            return this.$store.state.order.errors;
        },
    },
    mounted() {
        this.$store.dispatch('recipient/getRecipients');
    }
};
</script>
